import { createContext } from 'react';
export const defaultState = {
    gateway: null,
    gatewayConfig: null,
    lns: null,
    nodeEdgeMapper: null,
};
export const GatewayContextReducer = (prev, next) => {
    const update = { ...prev, ...next };
    return update;
};
export const GatewayConfigContext = createContext({
    state: defaultState,
    dispatch: () => {
        throw new Error('Dont use uninitialized GatewayContext');
    },
});
